import { StatusLog } from '../../../project/models/status-log.model';
import { AgreementCreationInfo } from './agreement-creation-info.model';
import { Attachment } from '../../../project/models/attachment.model';

export class Agreement {
  id: string;
  completedAgreementAttachment: Attachment;
  creationInfo: AgreementCreationInfo;
  sender: string;
  sent: Date;
  statuses: StatusLog[];

  constructor(agreement?: any) {
    agreement = agreement || {};
    this.id = agreement.id || null;
    this.completedAgreementAttachment = agreement.completedAgreementAttachment
      ? new Attachment(agreement.completedAgreementAttachment)
      : null;
    this.creationInfo = agreement.creationInfo
      ? new AgreementCreationInfo(agreement.creationInfo)
      : null;
    this.sender = agreement.sender || null;
    this.sent = agreement.sent ? new Date(agreement.sent) : null;
    this.statuses =
      agreement.statuses && agreement.statuses.length > 0
        ? agreement.statuses.map(
            (status: StatusLog) => new StatusLog(status)
          )
        : [];
  }
}
